import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { SsoComponent } from './sso.component';

// Routing
import { SsoRoutingModule } from './sso-routing.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SsoComponent],
  imports: [CommonModule, SsoRoutingModule, RouterModule],
  exports: [SsoComponent],
})
export class SsoModule {}
